import logoSrc from './cursor-insight-logo.svg';

const Logo = () => (
  <img src={logoSrc} alt="Cursor Insight Logo" />
);

export default Logo;
